<template>
  <div :class="rootClasses">
    <component :blok="blok" :is="blok.component"></component>
  </div>
</template>
<script>
import StoryblokClient from "storyblok-js-client";
import { mapActions, mapState } from "vuex";

export default {
  name: "shared-content",
  props: {
    story: String,
    draft: Boolean
  },
  data() {
    return {
      blok: {}
    };
  },
  async mounted() {
    const story = await this.getStoryById({
      id: this.$props.story,
      draft: this.$props.draft
    });
    this.blok = story.data.story.content;
  },
  methods: {
    ...mapActions("storyblok", ["getStoryById"]),
  },
  computed: {
    rootClasses: function() {
      const b = this.blok;
      return [
        b.contain ? "container" : "container-fluid",
        b.theme,
        b.component
      ];
    }
  }
};
</script>
